// Youth Foresight Fellows information for each region - Real data from UNICEF workshops
export const youthForesightFellows = {
  'Ecuador': {
    name: 'Sofía Monserrath Toapanta Arroyo',
    childRights: [
      'Best interests of the child',
      'Life survival and development',
      'Respect for children\'s views',
      'Aims of education'
    ],
    workshops: 7,
    participants: 99,
    quote: 'This experience reminded me that youth foresight is not only a methodology---it\'s an act of reclaiming the right to imagine.',
    focusAreas: [
      'Youth assemblies',
      'Empathy cultivation',
      'Well-being in schools',
      'Emotional intelligence'
    ]
  },
  'Ghana': {
    name: 'Beatrice Afia Wilson',
    childRights: [
      'Access to information',
      'Access to education',
      'Aims of education'
    ],
    workshops: 4,
    participants: 64,
    quote: 'Young people understand their concerns and dreams the best. They need to be given a platform if we really want to create a future that matters to them.',
    focusAreas: [
      'AI-powered learning',
      'Digital literacy',
      'Human-AI collaboration',
      'Youth platforms'
    ]
  },
  'Kazakhstan': {
    name: 'Korkemay Mukhitova',
    childRights: [
      'No discrimination',
      'Making rights real',
      'Children with disabilities',
      'Access to education'
    ],
    workshops: 3,
    participants: 24,
    quote: 'Youth foresight is not only about diverse perspectives, it is giving young people enough space and influence over the decisions that will shape their own futures.',
    focusAreas: [
      'Inclusive education',
      'Disability advocacy',
      'Empathy building',
      'Youth decision-making'
    ]
  },
  'Mauritania': {
    name: 'Soumeya Voulani',
    childRights: [
      'No discrimination',
      'Responsibility of parents',
      'Access to education',
      'Minority culture, language and religion'
    ],
    workshops: 2,
    participants: 19,
    quote: 'I got that second chance to pursue learning, and I want other girls to have it too.',
    focusAreas: [
      'Girls\' education advocacy',
      'Language accessibility',
      'Family engagement',
      'Second chances'
    ]
  },
  'Philippines': {
    name: 'Renz Nathaniel-Luyao',
    childRights: [
      'Respect for children\'s views',
      'Health, water, food, environment',
      'Access to education',
      'Aims of education'
    ],
    workshops: 2,
    participants: 25,
    quote: 'I feel proud that young Filipinos are building a brighter future where children and young people learn, lead, and live sustainably, proving that change is inevitable when we combine youth foresight and solidarity.',
    focusAreas: [
      'Climate education',
      'Indigenous knowledge',
      'Environmental action',
      'Youth solidarity'
    ]
  },
  'Kenya': {
    name: 'Crystal Isanda',
    childRights: [
      'Access to information',
      'Aims of education'
    ],
    workshops: 3,
    participants: 43,
    quote: '[The workshop] reminded me that we\'re not just imagining better futures, we\'re already rehearsing them. And it is youth leading the way.',
    focusAreas: [
      'AI education',
      'Emotional intelligence',
      'Meta-learning',
      'Youth leadership'
    ]
  },
  'France': {
    name: 'Juliette Font',
    childRights: [
      'No discrimination',
      'Respect for children\'s views',
      'Sharing thoughts freely',
      'Minority culture, language and religion'
    ],
    workshops: 1,
    participants: 20,
    quote: 'Youth foresight matters because the classrooms of today decide the freedoms of tomorrow.',
    focusAreas: [
      'Gender inclusivity',
      'Policy implementation',
      'Intersectional education',
      'Freedom of expression'
    ]
  },
  'Madagascar': {
    name: 'Ifaliana Lahatriniavo Rasidinantenaina',
    childRights: [
      'Access to education',
      'Aims of education'
    ],
    workshops: 4,
    participants: 243,
    quote: 'I feel deeply connected to the participants because I\'m also a young person, I understand what they go through, and I feel what they feel.',
    focusAreas: [
      'Cultural values',
      'Career orientation',
      'Community solidarity',
      'Youth connection'
    ]
  },
  'Norway': {
    name: 'Ronit Batra',
    childRights: [
      'Respect for children\'s views',
      'Access to information',
      'Aims of education'
    ],
    workshops: 1,
    participants: 31,
    quote: 'Youth foresight isn\'t just about seeing the future. It\'s about owning it. We don\'t just watch tomorrow unfold, we rebuild it into exactly what we want it to be.',
    focusAreas: [
      'AI mentorship',
      'Personalized learning',
      'Technology ethics',
      'Future ownership'
    ]
  },
  'Algeria': {
    name: 'Ayoub Kaouane',
    childRights: [
      'Aims of education',
      'Rest, play, culture, arts'
    ],
    workshops: 4,
    participants: 87,
    quote: 'Many expressed that we need more of these kinds of spaces where young people can think critically about the future together.',
    focusAreas: [
      'Extracurricular activities',
      'Practical learning',
      'Alumni mentorship',
      'Critical thinking spaces'
    ]
  },
  'Senegal': {
    name: 'Moustapha Dabo',
    childRights: [
      'No discrimination',
      'Protection from violence',
      'Access to education'
    ],
    workshops: 3,
    participants: 48,
    quote: 'I was pleasantly surprised by [the participants\'] commitment, and I was able to listen to their honest thoughts.',
    focusAreas: [
      'Girls\' education',
      'Safety in schools',
      'Mental health',
      'Honest dialogue'
    ]
  },
  'Haiti': {
    name: 'Annaëlle Narcisse',
    childRights: [
      'Life survival and development',
      'Access to information',
      'Protection from violence',
      'Access to education',
      'Protection from harmful work'
    ],
    workshops: 1,
    participants: 18,
    quote: 'Leading [this workshop] is a powerful way to invite people to think deeply about and share openly their opinions about the current situation and possible futures.',
    focusAreas: [
      'Mobile learning',
      'Peace education',
      'Conflict resilience',
      'Open dialogue'
    ]
  },
  'Guinea-Bissau': {
    name: 'Natálio Alfredo Cá',
    childRights: [
      'Health, water, food, environment',
      'Access to education',
      'Aims of education'
    ],
    workshops: 2,
    participants: 19,
    quote: 'Youth foresight equips young people with the capacity and vision to create solutions to current challenges for a desired and sustainable future.',
    focusAreas: [
      'Climate education',
      'Environmental resilience',
      'Sustainable learning',
      'Solution creation'
    ]
  },
  'India': {
    name: 'Sampada Tewari',
    childRights: [
      'No discrimination',
      'Access to education'
    ],
    workshops: 3,
    participants: 99,
    quote: 'All young girls, no matter their background, are very much aware of their schooling experiences and wish to see changes made.',
    focusAreas: [
      'Girls\' education',
      'Safe spaces',
      'Gender-neutral learning',
      'Educational awareness'
    ]
  },
  'United States of America': {
    name: 'Izumi Vazquez',
    childRights: [
      'Access to education',
      'Aims of education'
    ],
    workshops: 1,
    participants: 5,
    quote: 'Youth foresight matters because it refuses to treat young people as passive recipients of the future, instead centering OUR lived realities and visions to empower us and build the collective capacity to shape the systems we will inherit and transform.',
    focusAreas: [
      'Educational equity',
      'Alternative pathways',
      'Accessible learning',
      'Youth empowerment'
    ]
  }
};

// Helper function to get Fellow information for a region
export const getFellowInfo = (region) => {
  return youthForesightFellows[region] || null;
};